import React from 'react';
import "../assets/css/header.css"

const Header = () => {
    return (
        <>
            <div className="header">
            </div>
        </>
    );
};

export default Header;